import React from "react";

export default function TrashIcon({
	color = "#78909C",
	width = 24,
	height = 24,
}) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.1667 5.33333H16.1667V2.83333C16.1667 2.61232 16.0789 2.40036 15.9226 2.24408C15.7663 2.0878 15.5543 2 15.3333 2H8.66667C8.44565 2 8.23369 2.0878 8.07741 2.24408C7.92113 2.40036 7.83333 2.61232 7.83333 2.83333V5.33333H2.83333C2.61232 5.33333 2.40036 5.42113 2.24408 5.57741C2.0878 5.73369 2 5.94565 2 6.16667C2 6.38768 2.0878 6.59964 2.24408 6.75592C2.40036 6.9122 2.61232 7 2.83333 7H21.1667C21.3877 7 21.5996 6.9122 21.7559 6.75592C21.9122 6.59964 22 6.38768 22 6.16667C22 5.94565 21.9122 5.73369 21.7559 5.57741C21.5996 5.42113 21.3877 5.33333 21.1667 5.33333ZM9.5 3.66667H14.5V5.33333H9.5V3.66667Z"
				fill={color}
			/>
			<path
				d="M4.5 8.66699V19.5003C4.5 20.1634 4.76339 20.7993 5.23223 21.2681C5.70107 21.7369 6.33696 22.0003 7 22.0003H17C17.663 22.0003 18.2989 21.7369 18.7678 21.2681C19.2366 20.7993 19.5 20.1634 19.5 19.5003V8.66699H4.5ZM15.6783 17.8212L14.5 19.0003L12 16.5003L9.5 19.0003L8.32167 17.8212L10.8217 15.3212L8.32167 12.8212L9.5 11.6428L12 14.1428L14.5 11.6428L15.6783 12.8212L13.1783 15.3212L15.6783 17.8212Z"
				fill={color}
			/>
		</svg>
	);
}
